import { render, staticRenderFns } from "./ChatControls.vue?vue&type=template&id=1dbb3ec9&scoped=true&"
import script from "./ChatControls.vue?vue&type=script&lang=js&"
export * from "./ChatControls.vue?vue&type=script&lang=js&"
import style0 from "./ChatControls.vue?vue&type=style&index=0&id=1dbb3ec9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbb3ec9",
  null
  
)

export default component.exports